"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("@react-mdc/base");
var constants_1 = require("./constants");
var utils_1 = require("./utils");
exports.propertyClassNames = {
    TRANSITION: constants_1.BASE_CLASS_NAME + "-transition",
};
/**
 * Elevation component
 */
var Meta = (function (_super) {
    __extends(Meta, _super);
    function Meta() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Meta.prototype.renderBaseClassName = function (_c) {
        return utils_1.classNameForZSpace(this.props.zSpace);
    };
    Meta.prototype.renderClassValues = function (_c) {
        return [(_a = {},
                _a[exports.propertyClassNames.TRANSITION] = this.props.transition,
                _a)];
        var _a;
    };
    return Meta;
}(base_1.ClassNameMetaBase));
exports.Meta = Meta;
var Elevation = (function (_super) {
    __extends(Elevation, _super);
    function Elevation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Elevation.prototype.getMetaComponent = function () {
        return Meta;
    };
    Elevation.prototype.getMetaPropNames = function () {
        return [
            "className",
            "zSpace",
            "transition",
        ];
    };
    Elevation.prototype.getChildComponent = function () {
        return "div";
    };
    Elevation.Meta = Meta;
    return Elevation;
}(base_1.DefaultComponentBase));
exports.default = Elevation;
//# sourceMappingURL=Elevation.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/elevation/lib/Elevation.js
// module id = ./node_modules/@react-mdc/elevation/lib/Elevation.js
// module chunks = 1